import { render, staticRenderFns } from "./WafLoadingSpinner.vue?vue&type=template&id=01685535&scoped=true"
import script from "./WafLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./WafLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./WafLoadingSpinner.vue?vue&type=style&index=0&id=01685535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01685535",
  null
  
)

export default component.exports